// ! Can not convert to TS right now due to a issue w/ c3 tsconfig
// c3 does not transpile the TS code right now
import { getCdnHostName } from '@paypalcorp/c3-shared-globals';

const FLAGS_SPRITE_URL = `https://${getCdnHostName()}/digitalassets/c/website/marketing/global/shared/global/country-worldwide/sprite_countries_flag5.png`; // eslint-disable-line max-len

export { FLAGS_SPRITE_URL };
